import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Layout, Menu, Dropdown, Icon } from "antd";
import { compose } from "redux";
import { withFirestore } from "react-redux-firebase";
import { withRouter } from "react-router";

import { signOut } from "../actions/auth";

const { Header } = Layout;

class HeaderMenu extends Component {
  renderContent = menu => {
    switch (this.props.auth.uid) {
      case null:
        return;
      case undefined:
        return <Menu.Item key="/google" style={{ float: "right" }} />;
      default:
        return [
          <Dropdown key="7" overlay={menu}>
            <div style={{ float: "right" }}>
              Profile <Icon type="down" />
            </div>
          </Dropdown>,
          <Menu.Item key="/recipients" style={{ float: "right" }}>
            <Link to="/recipients">Recipient</Link>
          </Menu.Item>,
          <Menu.Item key="/campaigns" style={{ float: "right" }}>
            <Link to="/campaigns">Campaign</Link>
          </Menu.Item>,
          <div key="user" style={{ float: "right", marginRight: 20 }}>
            <Icon type="user" style={{marginRight: 5}}/>
            {this.props.auth.displayName || this.props.auth.email}
          </div>,
          <Fragment key="8" />
        ];
    }
  };

  render() {
    const menu = (
      <Menu>
        <Menu.Item key="/profile">
          <Link to="/account">Profile</Link>
        </Menu.Item>
        <Menu.Item key="/settings">
          <Link to="/settings">Settings</Link>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="/login" onClick={this.props.signOut}>
          Log Out
        </Menu.Item>
      </Menu>
    );

    const { location } = this.props;

    return (
      <Header style={{ backgroundColor: "white" }}>
        <div className="logo">
          <h3>Mail Hopper</h3>
        </div>
        <Menu
          theme="light"
          mode="horizontal"
          defaultSelectedKeys={["2"]}
          selectedKeys={[location.pathname]}
          style={{ lineHeight: "64px" }}
        >
          {this.renderContent(menu)}
        </Menu>
      </Header>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    signOut: () => dispatch(signOut(ownProps))
  };
};

export default compose(
  withFirestore,
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(HeaderMenu);
